module.exports = __webpack_public_path__ + "static/media/filter-gender-diverse.c7a735ac.svg";